module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm4"
    }
  }, [_c('p', [_vm._v("For my uncle, Leonard Rudnick")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticStyle: {
      "font-size": "x-small"
    }
  }, [_vm._v("At first I thought that the Leonard Rudnick of my childhood bore little resemblance to the Leonard Rudnick of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hard Target")]), _vm._v(". But then I realized that both are doctors who care deeply about their patients, and both are good souls who would do anything for a person in need. Moreover, both overcame substantial adversities as youngsters to lead rewarding lives.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticStyle: {
      "font-size": "x-small"
    }
  }, [_vm._v("On a personal level, my uncle has had a profound effect on me, starting with my earliest childhood memories when we went fishing in Bay Shore, New York and caught a large...boot. That taught me that fishing was not the sport for me.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticStyle: {
      "font-size": "x-small"
    }
  }, [_vm._v("My uncle also introduced me to chiropractic. Chiropractic treatment not only cured my blinding migraine headaches, but it brought me across the country to California, where I started a rewarding career and met the most important person of my life. There have been other influences, too numerous to record here, but suffice it to say that my uncle’s smile, humor, warmth, and wisdom have helped me become the person that I am today.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticStyle: {
      "font-size": "x-small"
    }
  }, [_vm._v("Unk, this one’s for you.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fb4c34f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 75
// module chunks = 0